const doc = [({"zh_cn":({"adminConstantHotelCheckInAnswererType":({"guest":"顾客", "hotel":"机构"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;